
import { Component, Vue } from "vue-property-decorator";
import GeneralFooter from "@/components/general-footer.vue";
import { Action, Getter, Mutation } from "vuex-class";
import { FormValues } from "@/interfaces/FormValues";
import { FORMULAR_AUSWAHL_ROUTE_NAME } from "@/router";
import { SubmissionPayload } from "@/store/actions";

@Component({
  components: {
    GeneralFooter,
  },
})
export default class FinishOrder extends Vue {
  @Action("submitAllFormValues")
  submitAllFormValues!: (payload: SubmissionPayload) => Promise<void>;

  @Getter("allFormValues")
  allFormValues!: Record<string, FormValues>;

  @Getter("userEmail")
  userEmail!: string;

  @Getter("bankName")
  bankName!: string;

  @Mutation("resetFormValues")
  resetFormValues!: () => void;

  public prev(): void {
    this.$router.go(-1);
  }

  public next(): void {
    this.$router.push({ name: FORMULAR_AUSWAHL_ROUTE_NAME });
  }
  public async submit(): Promise<void> {
    // since this is the last form page, submit values to backend
    const submissionPayload: SubmissionPayload = {
      formPages: this.allFormValues,
      userEmail: this.userEmail,
      sequenceName: this.bankName,
    };

    try {
      await this.submitAllFormValues(submissionPayload);
      this.resetFormValues();
      this.$fire({
        title: "Herzlichen Dank für Ihre Bestellung",
        html:
          "</br>Sie erhalten in Kürze eine automatische Bestätigungsemail.</br></br>" +
          "Bitte beachten Sie, dass Sie im Falle eines gewünschten Previews von uns kontaktiert werden. " +
          "Bei normalen Signage Spots dauert unsere Bearbeitungszeit rund 2 Tage.",
        confirmButtonText: "Zum Start",
      }).then((result) => {
        // 'result.value = true' if user pressed "OK"
        if (result.value === true) {
          this.next();
        }
      });
    } catch (e) {
      this.$fire({
        title: "Ein Fehler ist aufgetreten.",
        html:
          "</br>Leider konnte die Bestellung nicht abgeschickt werden.</br>" +
          "Bitte versuchen Sie es später nochmals. Wir entschuldigen uns für die Unannehmlichkeiten.</br></br>" +
          "Ihre Daten sind gespeichert, solange Sie diesen Browser Tab nicht schliessen.",
        confirmButtonText: "Zurück zur Startseite",
        cancelButtonText: "Schliessen",
        showCancelButton: true,
      }).then((result) => {
        // 'result.value = true' if user pressed "OK"
        if (result.value === true) {
          this.next();
        }
      });
    }
  }
}
